import React from "react";
import './HorizontalRadioButton.css';
import tr from '../../../libs/tr'

class HorizontalRadioButton extends React.Component {
  constructor(props) {
    super();

    this.state = {
      agree: false,
    };
  }

  render() {

    return (
      <div>
        <div className="col-12 col-lg-6 mb-2 mb-lg-0" style={!this.props.isMobile ? {paddingBottom: '8px'} : {}}>
          <div className="sn_cbox">
            <label className={this.state.agree ? "radioBold" : ""}>
              <span className="spaceIn">{tr.t("Agree")}</span>
              <input
                type="checkbox"
                name={this.props.index}
                checked={this.state.agree}
                onClick={(e) => {
                  this.setState({ agree: true });
                  this.props.controller(e);
                }}
              />
              <span className="checkmarkHRB"></span>
            </label>
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="sn_cbox">
            <label className={!this.state.agree ? "radioBold" : ""}>
              <span className="spaceIn">{tr.t("Nagree")}</span>
              <input
                type="checkbox"
                name={this.props.index}
                checked={!this.state.agree}
                onClick={(e) => {
                  this.setState({ agree: false });
                  this.props.controller(e);
                }}
              />
              <span className="checkmarkHRB"></span>
            </label>
          </div>
        </div>
      </div>
    );
  }
}

export default HorizontalRadioButton;


// WEBPACK FOOTER //
// ./src/assets/components/radiobtn/HorizontalRadioButton.js